import styled from 'styled-components';
import { Text15Light, Text16Light, Text20Bold } from '../../../components/utils/Text/Text.styles';
import { Button } from '../../../components/utils/Button/Button';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 2.4rem 0;

  @media only screen and (max-width: 500px) {
    padding: 1.6rem 1.2rem;
  }
`;

export const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  flex: 1;
  max-width: 42rem;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const NoteText = styled(Text15Light)`
  line-height: 2.2rem;
  opacity: 0.7;
  margin-top: 1.8rem;
  margin-bottom: 2rem;
`;

export const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  border-radius: 16px;
  border: 1px solid #61ade9;
  background: linear-gradient(180deg, #1a88df 0%, #1672ba 100%);
  padding: 0 1.2rem 0 0.6rem;
  box-shadow: none;
  height: 4.4rem;
  margin-top: 3rem;
`;

export const Title = styled(Text20Bold)`
  letter-spacing: -0.408px;
`;

export const Subtitle = styled(Text16Light)`
  margin-top: 1.8rem;
  margin-bottom: 2rem;
`;
